import {Component} from '@angular/core';

@Component({
    selector: 'app-store',
    imports: [],
    templateUrl: './store.component.html',
    styleUrl: './store.component.scss'
})
export class StoreComponent {

    saySomething() {

        alert('My Name Is Computer');

    }

}
